import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { VariableSummary } from '@mtna/pojo-consumer-ui';

/**
 * Variable List Component to display variable properties.
 *
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Component({
  selector: 'rds-variable-list',
  templateUrl: './variable-list.component.html',
  styleUrls: ['./variable-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RdsVariableListComponent {
  /** Provides active color for selected variable  */
  @Input() activeVariable: VariableSummary;
  /** When a variable is clicked, user is navigated to `/baseUrl/ + variable.id`. Defaults to "/variables/" */
  @Input() baseUrl = '/variables/';
  /** Debounce for variable search */
  @Input() debounceSearch = 500;
  /** Whether the list is loading variables */
  @Input() loading: boolean;
  /** Required variables to display */
  @Input() variables: Array<VariableSummary>;
  /** Text the user wants to search for in the list of variables */
  @Output()
  search = new EventEmitter<string>();

  trackByFn(variable) {
    if (!variable) {
      return null;
    }
    return variable.uri || variable.id;
  }

  handleSearch(text: string) {
    this.search.emit(text);
  }
}
